// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../graphql/api/index';

export const QuestionnaireQuestionTextFragmentDoc = `
    fragment questionnaireQuestionText on QuestionnaireQuestionText {
  id
  title
  label
  placeholder
  required
  textarea
}
    `;